const OtpInputStyles = {
  otpGroup: {
    display: "flex",
    width: "100%",
    maxWidth: "360px",
    columnGap: "10px",
  },
  otpInput: {
    width: "100%",
    height: "60px",
    border: "1px solid #ccc",
    borderRadius: "5px",
    textAlign: "center",
    fontSize: "32px",
    fontWeight: "bold",
    lineHeight: "1",
  },
  inputFeild: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "3rem",
    textAlign: "center",
    borderRadius: "4px",
    "& .MuiInputBase-input": {
      textAlign: "center",
      backgroundColor: "#f5f7f9",
      borderRadius: "4px",
      color: "#3d3e58",
    },
  },
};

export default OtpInputStyles;
